<template>
    <div class="body-editor">
        <label>{{ $t('whatsapp_business_api.bodyLabel') }} <span class="required">*</span></label>
        <a-textarea
            :value="body"
            @input="$emit('update:body', $event.target.value)"
            :placeholder="$t('whatsapp_business_api.bodyPlaceholder')"
            :rows="rows"
            :maxLength="1024"
        />
        <div class="textarea-footer">
            <div class="format-buttons" v-if="!disableFormatting">
                <a-tooltip :title="$t('whatsapp_business_api.bold')">
                    <a-button size="small" @click="insertFormat('*')">B</a-button>
                </a-tooltip>
                <a-tooltip :title="$t('whatsapp_business_api.italic')">
                    <a-button size="small" @click="insertFormat('_')"><i>I</i></a-button>
                </a-tooltip>
                <a-tooltip :title="$t('whatsapp_business_api.strikethrough')">
                    <a-button size="small" @click="insertFormat('~')"><s>S</s></a-button>
                </a-tooltip>
                <a-button size="small" @click="addVariable">+ {{ $t('whatsapp_business_api.addVariable') }}</a-button>
            </div>
            <span class="char-count">{{ (body || "").length }}/1024</span>
        </div>
        <span class="error-text" v-if="errorMessage">{{ errorMessage }}</span>

        <!-- Body Variables -->
        <div v-if="variables.length" class="variables-section">
            <div class="variables-header">
                <span>{{ $t("whatsapp_business_api.variables") }}</span>
                <span>{{ $t("whatsapp_business_api.defaultVariableName") }}</span>
            </div>
            <div v-for="(variable, i) of variables" :key="i" class="variable-row">
                <a-input :value="variable.variable" disabled />
                <a-input
                    :value="variable.example"
                    @input="updateVariableExample(i, $event.target.value)"
                    :placeholder="$t('whatsapp_business_api.example')"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "BodyEditor",
    props: {
        body: { type: String, default: "" },
        variables: { type: Array, default: () => [] },
        errorMessage: { type: String, default: null },
        rows: { type: Number, default: 6 },
        disableFormatting: { type: Boolean, default: false },
    },
    methods: {
        insertFormat(char) {
            this.$emit('insert-format', char);
        },
        addVariable() {
            this.$emit('add-variable');
        },
        updateVariableExample(index, value) {
            this.$emit('update-variable-example', { index, value });
        },
    },
});
</script>

<style scoped lang="scss">
.body-editor {
    label {
        display: block;
        margin-bottom: 8px;
        font-weight: 500;

        .required {
            color: #ff4d4f;
        }
    }

    .textarea-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 8px;

        .format-buttons {
            display: flex;
            gap: 8px;
        }

        .char-count {
            font-size: 12px;
            color: #999;
        }
    }

    .error-text {
        display: block;
        color: #ff4d4f;
        font-size: 12px;
        margin-top: 4px;
    }

    .variables-section {
        margin-top: 16px;
        padding: 12px;
        background: #fafafa;
        border-radius: 6px;
        border: 1px solid #e8e8e8;

        .variables-header {
            display: flex;
            gap: 12px;
            margin-bottom: 8px;
            font-weight: 500;
            font-size: 13px;
            color: #666;

            span {
                flex: 1;
            }
        }

        .variable-row {
            display: flex;
            gap: 12px;
            margin-bottom: 8px;

            &:last-child {
                margin-bottom: 0;
            }

            .ant-input {
                flex: 1;
            }

            .ant-input:disabled {
                background: #f0f0f0;
                color: #1890ff;
                font-weight: 500;
            }
        }
    }
}
</style>
